/* eslint-disable max-statements */
/* eslint-disable max-lines */
import { useState } from "react"
import { useLocation } from "react-router-dom"
import { SchedulesListStateType } from "../../../../models/list"
import { useExportFile } from "../useExportFile"
import { useRouters } from "../useRouters"
import { useApi } from "../useApi"
import { useTableConfig } from "../useTableConfig"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { getBreadcrumbItems } from "./getBreadcrumbItems"
import { useDatePicker } from "../../../../../../../utils/hook/useDatePicker"
import { Routers } from "../../../../../../../constant/Routers"
import { getAllCountries } from "../../../../../../../utils/apis/getAllCountries"

const { SCR210 } = Routers

export const useVariables = () => {
  const { state, pathname } = useLocation<SchedulesListStateType>()
  const breadcrumbItems = getBreadcrumbItems(
    pathname,
    state?.isFromSCR114UserSearch,
  )
  const { allCountries } = getAllCountries({ isFilterJapan: true })
  // 画面のメインボタンの初期表示処理を行う。
  const {
    isAuthorities,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isRoleSubAdmin,
  } = useVariablesAuthority(state?.isFromSCR114UserSearch)

  const isGetCountries = pathname !== SCR210 && isRoleSubAdmin

  const {
    arrivalCities,
    countries,
    dataSource,
    dataSourceSelected,
    departments,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    handleCancelEmptySearchCondition,
    handleOpenEmptySearchCondition,
    handleSearch,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isLoadingLayout,
    isLoadingTable,
    isOpenEmptySearchCondition,
    isPathnameAttentionsOrSafeties,
    isResetTable,
    onChange,
    onChangeDispatchType,
    onChangeTable,
    onFinish,
    perItem,
    purposeTravel,
    rowSelection,
    searchCondition,
    selectedRowKeys,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingTable,
    setIsLoadingLayout,
    setSearchCondition,
    setTravelerId,
    sortedInfo,
    travelScheduleId,
    userInformation,
  } = useApi({ isGetCountries, isPathnameTravelers, isRoleSubAdmin })

  const {
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    isOpenModalExport,
    messageConfirmDownload,
    push,
  } = useExportFile({
    dataSource,
    form,
    selectedRowKeys,
    setIsLoadingTable,
  })

  const {
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
  } = useRouters({
    dataSourceSelected,
    isFromSCR114UserSearch: state?.isFromSCR114UserSearch,
    searchCondition,
    searchConditionTraveler: state?.searchConditionTraveler,
    travelScheduleId,
    travelerId: state?.travelerId,
  })
  const { onBlur: onBlurBasic, onKeyDown: onKeyDownBasic } = useDatePicker({
    form,
  })

  const [isDisabledArrivalCity, setIsDisabledArrivalCity] = useState(true)

  const { columns } = useTableConfig(isPathnameSchedules, sortedInfo)

  return {
    allCountries,
    arrivalCities,
    breadcrumbItems,
    columns,
    countries,
    dataSource,
    departments,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    getArrivalCities,
    getData,
    getSchedules,
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
    handleCancelEmptySearchCondition,
    handleCancelModalExport,
    handleExportFile,
    handleOpenEmptySearchCondition,
    handleOpenModalExport,
    handleSearch,
    isAuthorities,
    isDisabledArrivalCity,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isFromSCR114UserSearch: state?.isFromSCR114UserSearch,
    isGetCountries,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isLoadingLayout,
    isLoadingTable,
    isOpenEmptySearchCondition,
    isOpenModalExport,
    isPathnameAttentionsOrSafeties,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isResetTable,
    messageConfirmDownload,
    onBlurBasic,
    onChange,
    onChangeDispatchType,
    onChangeTable,
    onFinish,
    onKeyDownBasic,
    pathname,
    perItem,
    purposeTravel,
    push,
    rowSelection,
    setIsDisabledArrivalCity,
    setIsDisabledDispatchTypeDetail,
    setIsLoadingLayout,
    setSearchCondition,
    setTravelerId,
    state,
    userInformation,
  }
}
